import BaseGetters from '@/store/base/getters'

export default BaseGetters({
  getCategoryListByKey: state => key => {
    return typeof state.module[key] !== 'undefined' ? state.module[key] : []
  },
  getBrands: state => state.module['main'] ?? [],
  fetchedCounts: state => state.fetchedCounts,
})